import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, of } from 'rxjs';
import { PershingError } from '../models/pershing-error.model';
import { DomainContext, AccountContextValue, UserContext } from '../models/context.model';
import { IContextService } from '../interfaces/context.abstract.service';
import { CoreConstants } from '../constants/core-constants';

@Injectable()
export class ContextServiceMock implements IContextService {
    private _error: BehaviorSubject<PershingError> = new BehaviorSubject<PershingError>({
        errorMessage: 'Test Error Message',
        errorCode: null,
        className: 'ContextService',
        timestamp: null
    });
    error$: Observable<PershingError> = this._error.asObservable();
    selectedDomainContext$: Observable<DomainContext<any>> = of({
        domain: CoreConstants.ACCOUNT,
        value: new AccountContextValue('ABC123XYZ')
    });
    selectedOrgContext$: Observable<any> = new Observable();
    defaultContext: any;
    hasError: boolean;

    constructor() { }

    clearContextError = () => {
        this._error.next(null);
    }

    setDomainContext(domain: string, value: any): void { }

    setOrgDomainContext(domain: string, value: any): void { }

    getDeviceType(): any {
        return null;
    }

    clearContext(): void { }

    saveLocalStorage(): void { }

    isAuthenticated(): boolean {
        return true;
    }

    setContextError(errorMessage: string, errorCode?: string) { }

    setDeviceType(deviceType: string) { }

    setGotoContext(goToContext: string) { }

    getGotoContext() { return undefined; }

    setRouteContext(routerContext: string) { }

    getRouteContext() { return undefined; }

    setUserContext(userContext: UserContext) { }

    getUserContext() {
        return undefined;
    }
}
